import StorekeepersFreights from './views/Freights.vue'
import StorekeepersFreight from './views/Freight.vue'
import StorekeepersIssueFreight from './views/IssueFreight.vue'
import FreightPrintTicket from './views/print/FreightTicketPrint.vue'
import FreightPrintStockNote from './views/print/FreightPrintStockNote.vue'
import StorekeepersItineraries from './views/StorekeepersItineraries.vue'
import StorekeepersItinerary from './views/StorekeepersItinerary.vue'

export default {
    routes: [
        {
            path: '/module/storekeepers/freights',
            name: 'StorekeepersFreights',
            component: StorekeepersFreights,
            meta: {toolbars: ['Freights'], tab: 'storekeepers-freights'}
        },
        {
            path: '/module/storekeepers/freights/:id',
            name: 'StorekeepersFreight',
            components: {default: StorekeepersFreights, right: StorekeepersFreight},
            meta: {toolbars: ['Freights'], tab: 'storekeepers-freights'}
        },
        {
            path: '/module/storekeepers/issue',
            name: 'StorekeepersIssueFreight',
            components: {default: StorekeepersFreights, right: StorekeepersIssueFreight},
            meta: {toolbars: ['Freights'], tab: 'storekeepers-freights'}
        },
        {
            path: '/module/storekeepers/print/ticket/',
            name: 'FreightPrintTicket',
            component: FreightPrintTicket
        },
        {
          path: '/module/storekeepers/print/stock_note/',
          name: 'FreightPrintStockNote',
          component: FreightPrintStockNote
        },

        {
            path: '/module/storekeepers/itineraries',
            name: 'StorekeepersItineraries',
            component: StorekeepersItineraries,
            meta: {tab: 'storekeepers-itineraries'}
        },
        {
            path: '/module/storekeepers/itineraries/:id',
            name: 'StorekeepersItinerary',
            components: {default: StorekeepersItineraries, right: StorekeepersItinerary},
            meta: {tab: 'storekeepers-itineraries'}
        }
    ]
}



// WEBPACK FOOTER //
// ./src/modules/storekeepers_stocks/routes.js